<ng-content select="[cm-text-top]"> </ng-content>
@if ($showSpinner()) {
    <cm-loading-spinner-icon></cm-loading-spinner-icon>
}
<ng-content select="[cm-text-bottom]"> </ng-content>
